

const ClientReducer = (state, action) => {
    switch (action.type) {
        case "GET_CLIENTS_START":
            return {
                ...state,
                clients: [],
                isFetching: true,
                error: false,
            };
        case "GET_CLIENTS_SUCCESS":
            return {
                ...state,
                clients: action.payload.clients,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_CLIENTS_FAILURE":
            return {
                ...state,
                clients: [],
                isFetching: false,
                error: action.payload,
            };
        case "ADD_CLIENT_START":
            return {
                ...state,
                client: {},
                isFetchingAdd: true,
                errorAdd: false,
            };
        case "ADD_CLIENT_SUCCESS":
            return {
                ...state,
                client: action.payload.client,
                isFetchingAdd: false,
                errorAdd: false,
            };
        case "ADD_CLIENT_FAILURE":
            return {
                ...state,
                client: {},
                isFetchingAdd: false,
                errorAdd: action.payload,
            };
        case "UPDATE_CLIENT_START":
            return {
                ...state,
                client: {},
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_CLIENT_SUCCESS":
            return {
                ...state,
                client: action.payload.client,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_CLIENT_FAILURE":
            return {
                ...state,
                client: {},
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
        case "ACTIVATE_CLIENT_START":
            return {
                ...state,
                client: {},
                isFetchingActivate: true,
                errorActivate: false,
            };
        case "ACTIVATE_CLIENT_SUCCESS":
            return {
                ...state,
                client: action.payload.client,
                isFetchingActivate: false,
                errorActivate: false,
            };
        case "ACTIVATE_CLIENT_FAILURE":
            return {
                ...state,
                client: {},
                isFetchingActivate: false,
                errorActivate: action.payload,
            };
        default:
            return { ...state };
    }
}

export default ClientReducer;